package `fun`.adaptive.ui.navigation.sidebar.theme

var fullSidebarTheme = FullSidebarTheme()
var thinSidebarTheme = ThinSidebarTheme()